interface CostSummaryProps {
  isCredit: boolean;
  estimatedCost: string;
  buyingPowerDisplay: string;
  buyingPowerLabel: string;
  occClearingFee: string;
  optionsRegulatoryFee: string;
  tafFee: string;
  catFee: string;
  /** Stop / stop-limit estimates use bid/ask until the stop triggers */
  showIndicativeEstimate?: boolean;
}

const FeeRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-start justify-between text-center text-xs leading-4">
    <span className="text-gray-600">{label}</span>
    <span className="font-medium font-mono text-gray-700">${value}</span>
  </div>
);

export const CostSummary = ({
  isCredit,
  estimatedCost,
  buyingPowerDisplay,
  buyingPowerLabel,
  occClearingFee,
  optionsRegulatoryFee,
  tafFee,
  catFee,
  showIndicativeEstimate = false,
}: CostSummaryProps) => (
  <div className="flex flex-col gap-1 whitespace-nowrap py-2">
    <div className="flex flex-col gap-0.5">
      <div className="flex items-center justify-between gap-2">
        <span className="font-medium text-gray-700 text-sm leading-5">
          Estimated {isCredit ? "Value" : "Cost"}
        </span>
        <span className="shrink-0 font-medium font-mono text-base text-gray-700 leading-[22px]">
          ${estimatedCost}
        </span>
      </div>
      {showIndicativeEstimate && (
        <p className="m-0 p-0 text-[10px] text-gray-500 leading-[14px]">
          Indicative estimate based on current bid/ask until triggered.
        </p>
      )}
    </div>
    <FeeRow label={buyingPowerLabel} value={buyingPowerDisplay} />
    <FeeRow label="OCC Clearing Fee" value={occClearingFee} />
    <FeeRow label="Options Regulatory Fee" value={optionsRegulatoryFee} />
    {tafFee !== "0.00" && (
      <FeeRow label="Trading Activity Fee" value={tafFee} />
    )}
    <FeeRow label="CAT Fee" value={catFee} />
  </div>
);
